export default __webpack_public_path__ + "static/media/btc_popup_text.5524f0c5.svg";